__turbopack_context__.v({
  "inline": "oNqwHq_inline",
  "line": "oNqwHq_line",
  "textReveal": "oNqwHq_textReveal",
});
